import Vue from "vue";
import Router from "vue-router";
import Main from "./views/Main.vue";

Vue.use(Router);

let router = new Router({
  // mode: "history",
  routes: [
    {
      path: "/",
      redirect: "/Index",
      component: Main,
      children: [
        {
          path: "Index",
          title: "Index",
          name: "Index",
          meta: {
            title: "概览"
          },
          component: resolve => require(["./views/Index.vue"], resolve)
        }
      ]
    },
    {
      path: "*",
      name: "404",
      meta: {
        title: "404页面"
      },
      component: resolve => require(["./views/404.vue"], resolve)
    },
    {
      path: "/Basic",
      title: "Basic",
      meta: {
        title: "基础"
      },
      component: Main,
      children: [
        {
          path: "Icon",
          title: "Icon",
          name: "Icon",
          meta: {
            title: "图标"
          },
          component: resolve =>
            require(["./views/Basic/Icon/Index.vue"], resolve)
        },
        {
          path: "Button",
          title: "Button",
          name: "Button",
          meta: {
            title: "按钮"
          },
          component: resolve =>
            require(["./views/Basic/Button/Index.vue"], resolve)
        }
      ]
    },
    {
      path: "/Layout",
      title: "Layout",
      meta: {
        title: "布局"
      },
      component: Main,
      children: [
        {
          path: "Grid",
          title: "Grid",
          name: "Grid",
          meta: {
            title: "栅格"
          },
          component: resolve =>
            require(["./views/Layout/Grid/Index.vue"], resolve)
        },
        {
          path: "Divider",
          title: "Divider",
          name: "Divider",
          meta: {
            title: "分割线"
          },
          component: resolve =>
            require(["./views/Layout/Divider/Index.vue"], resolve)
        }
      ]
    },
    {
      path: "/Form",
      title: "Form",
      meta: {
        title: "表单"
      },
      component: Main,
      children: [
        {
          path: "Input",
          title: "Input",
          name: "Input",
          meta: {
            title: "输入框"
          },
          component: resolve =>
            require(["./views/Form/Input/Index.vue"], resolve)
        },
        {
          path: "Switch",
          title: "Switch",
          name: "Switch",
          meta: {
            title: "开关"
          },
          component: resolve =>
            require(["./views/Form/Switch/Index.vue"], resolve)
        },
        {
          path: "Select",
          title: "Select",
          name: "Select",
          meta: {
            title: "选择器"
          },
          component: resolve =>
            require(["./views/Form/Select/Index.vue"], resolve)
        },
        {
          path: "Slider",
          title: "Slider",
          name: "Slider",
          meta: {
            title: "滑块"
          },
          component: resolve =>
            require(["./views/Form/Slider/Index.vue"], resolve)
        }
      ]
    },
    {
      path: "/Notice",
      title: "Notice",
      meta: {
        title: "通知"
      },
      component: Main,
      children: [
        {
          path: "Message",
          title: "Message",
          name: "Message",
          meta: {
            title: "消息提示"
          },
          component: resolve =>
            require(["./views/Notice/Message/Index.vue"], resolve)
        }
      ]
    }
  ]
});

router.beforeEach((to, from, next) => {
  window.document.title = to.meta.title + " - " + "Kata UI Toolkit v0.1";
  next();
});

router.afterEach((to, from, next) => {
  window.scrollTo(0, 0);
});

export default router;
